import { render, staticRenderFns } from "./ReadonlyField.vue?vue&type=template&id=92b797fc&scoped=true&"
import script from "./ReadonlyField.vue?vue&type=script&lang=js&"
export * from "./ReadonlyField.vue?vue&type=script&lang=js&"
import style0 from "./ReadonlyField.vue?vue&type=style&index=0&id=92b797fc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b797fc",
  null
  
)

export default component.exports